import {observer} from "mobx-react-lite"
import React, {useEffect, useState} from "react"
import controller from "../../store/pageControllers/StockSettingsController"
import CliApi from "../../api/CliApi"
import {TaskControls} from "../../components/task_buttons/TaskControls"
import {appPages} from "../../App"
import {Link} from "react-router-dom"
import classNames from "classnames"
import {Field, Fields, FieldsGroup, Select, WaCheckbox} from "../../lib/wa-2.0"
import Warehouse from "../../store/entities/Warehouse";
import WarehouseCondition from "../../store/entities/WarehouseConditions"
import {SelectProductsCategoriesOrSets} from "../../components/SelectProductsCategoriesOrSets";

export const StockUpdateSettings = observer(() => {
    const [activeWarehouse, setActiveWarehouse] = useState<string>()
    const [warehouseObj, setWarehouseObj] = useState<Warehouse>()

    useEffect(() => {
        controller.loadSettings()
    }, [])

    useEffect(() => {
        if (activeWarehouse) {
            const warehouse = controller.getActiveWarehouse(activeWarehouse)
            if (!warehouse) {
                setActiveWarehouse(controller.firstOzonWarehouse)
            }
        } else {
            setActiveWarehouse(controller.firstOzonWarehouse)
        }
    }, [controller.ozon_warehouses])

    useEffect(() => {
        const warehouse = controller.getActiveWarehouse(activeWarehouse)
        setWarehouseObj(warehouse)
    }, [activeWarehouse])

    useEffect(() => {
        // @ts-ignore
        $(".tabs.overflow-arrows").waTabs({
            arrows_side: 'both'
        })
    })

    return <div className="stock-settings custom-mt-32">
        {/*<h6>{"Обновление остатков".toUpperCase()}</h6>*/}

        <Fields>
            <Field label={"Сопоставить товары по:"}>
                <Select
                    className={"width-40"}
                    options={controller.productSyncByOptions}
                    value={controller.valueOfProductFindBy.value}
                    onChange={(e) => controller.productSyncBy = e.target.value}
                />
            </Field>
        </Fields>

        <Fields className={'custom-mt-20'}>
            <Field label={"Хранить историю обновления остатков:"}>
                <Select
                    className={"width-40"}
                    options={controller.historyOptions}
                    value={controller.historyDaysKeep}
                    onChange={(e) => controller.historyDaysKeep = Number(e.target.value)}
                />
            </Field>
        </Fields>


        <h6>{"Склады"}</h6>

        <ul className={"tabs overflow-arrows"}>
            {controller.ozon_warehouses?.map((warehouse, index) => <li
                key={index}
                className={classNames({selected: warehouse.id == activeWarehouse})}
                onClick={() => {
                    setActiveWarehouse(warehouse.id)
                }}
            >
                <a>
                    {warehouse.name} <br/>
                    <span className={"hint"}>
                        {warehouse.id}
                    </span>

                </a>
            </li>)}
            <li onClick={() => controller.updateWarehouses()}>
                <i className={'fa fa-sync cursor-pointer'}/>
            </li>
        </ul>
        {warehouseObj && <Fields className={"custom-mt-8"}>
            <FieldsGroup>
                <Field label={"Обновлять остатки"}>
                    <WaCheckbox
                        checked={warehouseObj.update_stocks}
                        onChange={(e) => warehouseObj.update_stocks = e.target.checked}
                    />
                </Field>
                <SelectProductsCategoriesOrSets
                    {...warehouseObj.productCollectionSettings}
                    addFromExportVariant={true}
                    changeState={state => warehouseObj.productCollectionSettings = state}
                />

                <Field label={"Выбрать склады"}>
                    <Select
                        className={"width-40"}
                        options={controller.warehousesOptions}
                        value={warehouseObj.stock_mode}
                        onChange={(e) => (e.target.value === 'all' || e.target.value === 'selected') ? warehouseObj.stock_mode = e.target.value : 0}
                    />
                    {warehouseObj.stock_mode === "selected" && <div>
                        {controller.shop_warehouses.map((shopWarehouse, index) => <div className="custom-mt-8"
                                                                                       key={index}>
                            <WaCheckbox
                                label={shopWarehouse.name}
                                checked={warehouseObj.stocks.includes(shopWarehouse.id)}
                                onChange={(event) => warehouseObj.changeWarehouse(shopWarehouse.id, event.target.checked)}
                            />
                        </div>)}
                    </div>
                    }
                </Field>
                <Field label={"При получении заказа списывать с этих же складов"}>
                    <WaCheckbox
                        checked={warehouseObj.write_off_goods}
                        onChange={(e) => warehouseObj.write_off_goods = e.target.checked}
                    />
                </Field>
                <Field label={"Остатки для ∞"}>
                    <input
                        className={"width-40"}
                        type={"text"}
                        value={warehouseObj.infinity_count}
                        onChange={event => warehouseObj.infinity_count = event.target.value}
                    />
                    <div className={"hint"}>Остатки товаров которые будут отправляться в OZON, если у товара
                        указано
                        наличие ∞.
                    </div>
                </Field>
                <Field label={"Если товар из Ozon не найден на сайте, то отправить наличие ноль"}>
                    <WaCheckbox
                        checked={warehouseObj.not_found_zero}
                        onChange={(e) => warehouseObj.not_found_zero = e.target.checked}
                    />
                </Field>
                <Field label={"Настройки подмены наличия"}>
                    {warehouseObj.conditions.map((condition, id) => <div
                        key={id}
                        className={'custom-mb-8'}
                    >
                        Если наличие
                        <Select
                            options={WarehouseCondition.conditions}
                            className={'condition custom-ml-4'}
                            value={condition.type}
                            onChange={event => condition.type = event.target.value}
                        />
                        <input
                            className={"width-20"}
                            type={"number"}
                            value={condition.if_value?.toString()}
                            onChange={event => condition.if_value = parseInt(event.target.value)}
                        />
                        , то ответить
                        <input
                            className={"width-20 custom-ml-4"}
                            type={"number"}
                            value={condition.then_value?.toString()}
                            onChange={event => condition.then_value = parseInt(event.target.value)}
                        />
                        <button
                            className={'button outlined red'}
                            onClick={() => warehouseObj.deleteCondition(id)}
                        ><i className={'fa fa-minus'}></i></button>
                    </div>)}
                    <button className='button outlined' onClick={() => warehouseObj.addCondition()}><i
                        className={'fa fa-plus'}/> Добавить условие
                    </button>
                </Field>
            </FieldsGroup>
        </Fields>
        }

    </div>
})